import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "ne_cookie_ack_v1";

/**
 * CookieBanner – minimal banner som vises på første besøk.
 */
export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Liten delay så banneren ikke konkurrerer med age gate
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch (_e) {
      // Hvis localStorage er deaktivert lar vi være å vise banneren
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch (_e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[var(--noir)] backdrop-blur-md"
      data-testid="cookie-banner"
      role="dialog"
      aria-labelledby="cookie-banner-title"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-5 flex flex-col md:flex-row gap-4 md:gap-8 items-start md:items-center">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-5 w-5 text-[var(--magenta)] mt-0.5 shrink-0" />
          <div>
            <div id="cookie-banner-title" className="font-meta text-[var(--cream)] mb-2">
              {t("cookies.title")}
            </div>
            <p className="text-sm text-[var(--cream-soft)] leading-relaxed">
              {t("cookies.body")}{" "}
              <Link to="/cookies" className="text-[var(--magenta)] underline-offset-4 hover:underline" data-testid="cookie-banner-link">
                {t("cookies.read_more")}
              </Link>.
            </p>
          </div>
        </div>
        <div className="flex gap-2 shrink-0 w-full md:w-auto">
          <button
            type="button"
            onClick={accept}
            className="btn-magenta flex-1 md:flex-none"
            data-testid="cookie-banner-accept"
          >
            {t("cookies.accept")}
          </button>
          <button
            type="button"
            onClick={accept}
            className="p-2 text-[var(--cream-faint)] hover:text-[var(--cream)] transition-colors"
            data-testid="cookie-banner-close"
            aria-label={t("cookies.close")}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
